import { InHouseOrderService } from "../../services/inHouseOrder.service";
import { IGroupOrderInviteService, GroupMember, JoinGroupResult, IGroupCodeInfo } from "./groupOrderInvite.facade";
import { OnDestroy, Injectable } from "@angular/core";
import Utils from "../../shared/utils";
import { CoreLogService } from "../../services/log.service";
import { GetPlaceStatus } from "../../services/IInHouseOrderService";
import { Router } from "@angular/router";

@Injectable()
export class GroupOrderInviteService implements IGroupOrderInviteService, OnDestroy {
  constructor(private _inHouseOrderService: InHouseOrderService
    , private _coreLogService: CoreLogService
    , private _router: Router
  ) {
  }

  ngOnDestroy(): void {
    // Führt Cleanup durch
    const me = this;
  }

  /** ermittelt, ob der benutzet bereits ein mitglied dieser oder einer anderen gruppe ist */
  public async isAlwasyMemberOfGroup(group_code: string): Promise<GroupMember> {
    const me = this;
    const currentUserGroupCode = me._inHouseOrderService.GroupCode;
    if (Utils.IsNullOrEmpty(currentUserGroupCode)) {
      return GroupMember.Not;
    } else if (currentUserGroupCode == group_code) {
      return GroupMember.Yes;
    } else {
      return GroupMember.OtherGroup;
    }
  }

  /** ermittelt informationen zum Gruppencode */
  public async getGroupCodeInfo(group_code: string): Promise<IGroupCodeInfo> {
    const me = this;

    const info = await me._inHouseOrderService.GetInfoFromGroupcode(group_code);

    const result: IGroupCodeInfo = {
      valide: info.group_code_info.valide,
      location: info.group_code_info.location,
      tableNo: info.group_code_info.table_no,
      groupInfo: {
        groupName: info.group_code_info.group_name,
        groupCreator: info.group_code_info.group_creator
      },
      isFull: info.group_code_info.is_full,
    }

    return result;
  }

  /** versucht dem Gruppencode beizutretten */
  public async joinGroup(nickname: string, location: number, table_no: string, group_name: string, group_code: string): Promise<JoinGroupResult> {
    const me = this;

    if (await me.isAlwasyMemberOfGroup(group_code) != GroupMember.Not) {
      this._coreLogService.error("GroupOrderInviteService.joinGroup", "isAlwasyMemberOfGroup");
      return JoinGroupResult.UserIsInGroup;
    }

    const newPlace = await me._inHouseOrderService.JoinGroupCode(group_code, nickname);
    if (newPlace.success) {
      me._router.navigate(["/groupOrderServiceSelector"]);
      return JoinGroupResult.Okay;
    } else {
      switch (newPlace.status) {
        case GetPlaceStatus.GroupFull:
          return JoinGroupResult.GroupFull;
        case GetPlaceStatus.WrongUserName:
          return JoinGroupResult.WrongUserName;
        case GetPlaceStatus.Fail, GetPlaceStatus.Error:
          return JoinGroupResult.Fail;
        default:
          me._coreLogService.error("GroupOrderInviteService.joinGroup", "unknown status", newPlace.status);
          return JoinGroupResult.Fail;
      }
    }
  }
}
